import { IconButton, Tooltip, TextField, InputAdornment, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cargarCreditoAEditar } from '../../store';
import { startConsultarCreditosPaginados } from '../../store/historicos';
import { listadoHistoricos } from '../../helper/coleccionCreditos';
import { MAIN_PATH, PATH_NAME } from '../../constants';
import Iconify from '../iconify/Iconify';
import TableListPagination from '../table-list/TableListPagination';

export const Historico = () => {
 const { creditos, loading, paginacion } = useSelector((state) => state.historicos);
 const [currentPage, setCurrentPage] = useState(1);
 const [searchTerm, setSearchTerm] = useState('');
 const [filtroEspecifico, setFiltroEspecifico] = useState(null);
 const [tipoFiltro, setTipoFiltro] = useState('creditoId');
 const [valorFiltro, setValorFiltro] = useState('');
 const navigate = useNavigate();
 const dispatch = useDispatch();
 
 // Efecto para cargar los datos con los filtros aplicados
 useEffect(() => {
   dispatch(startConsultarCreditosPaginados(currentPage, searchTerm, filtroEspecifico));
 }, [dispatch, currentPage, searchTerm, filtroEspecifico]);

 const handlePageChange = (page) => {
   setCurrentPage(page);
 };

 const handleSearch = (term) => {
   // Si ya hay un filtro específico activo, lo respetamos
   if (!filtroEspecifico) {
     setSearchTerm(term);
     setCurrentPage(1);
   }
 };

 const handleFiltroEspecifico = () => {
   if (valorFiltro.trim()) {
     setFiltroEspecifico({
       tipo: tipoFiltro,
       valor: valorFiltro.trim()
     });
     // Al aplicar un filtro específico, limpiamos la búsqueda general
     setSearchTerm('');
     setCurrentPage(1);
   }
 };

 const handleTipoFiltroChange = (event) => {
   setTipoFiltro(event.target.value);
   // Cuando cambia el tipo de filtro, limpiamos el valor
   setValorFiltro('');
   // Si había un filtro aplicado, lo limpiamos
   if (filtroEspecifico) {
     clearAllFilters();
   }
 };

 const handleValorFiltroChange = (event) => {
   setValorFiltro(event.target.value);
 };

 const clearAllFilters = () => {
   setFiltroEspecifico(null);
   setValorFiltro('');
   setSearchTerm('');
   setCurrentPage(1);
 };

 // Obtenemos la etiqueta para mostrar en el filtro
 const getTipoFiltroLabel = () => {
   switch (tipoFiltro) {
     case 'creditoId': return 'N. Crédito';
     case 'cedula': return 'Cédula';
     case 'nombre': return 'Nombre';
     default: return 'Valor';
   }
 };

 // Componente personalizado para la barra de herramientas de la tabla
 const customToolbar = () => {
   return (
     <Box sx={{ display: 'flex', gap: '16px', padding: '16px 24px', alignItems: 'center' }}>
       <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
         <InputLabel id="tipo-filtro-label">Filtrar por</InputLabel>
         <Select
           labelId="tipo-filtro-label"
           value={tipoFiltro}
           onChange={handleTipoFiltroChange}
           label="Filtrar por"
         >
           <MenuItem value="creditoId">N. Crédito</MenuItem>
           <MenuItem value="cedula">Cédula</MenuItem>
           <MenuItem value="nombre">Nombre</MenuItem>
         </Select>
       </FormControl>
       
       <TextField 
         label={`Buscar por ${getTipoFiltroLabel()}`} 
         variant="outlined"
         size="small"
         value={valorFiltro}
         onChange={handleValorFiltroChange}
         onKeyPress={(e) => {
           if (e.key === 'Enter') {
             handleFiltroEspecifico();
           }
         }}
         sx={{ minWidth: 220 }}
         InputProps={{
           endAdornment: (
             <InputAdornment position="end">
               {filtroEspecifico ? (
                 <IconButton
                   aria-label="Limpiar filtro"
                   onClick={clearAllFilters}
                   edge="end"
                   size="small"
                 >
                   <Iconify icon="material-symbols:close" />
                 </IconButton>
               ) : (
                 <IconButton
                   aria-label="Aplicar filtro"
                   onClick={handleFiltroEspecifico}
                   edge="end"
                   size="small"
                   disabled={!valorFiltro.trim()}
                 >
                   <Iconify icon="material-symbols:search" />
                 </IconButton>
               )}
             </InputAdornment>
           ),
         }}
       />
       {filtroEspecifico && (
         <Box sx={{ 
           display: 'flex', 
           alignItems: 'center', 
           backgroundColor: '#e3f2fd', 
           padding: '4px 12px', 
           borderRadius: '16px',
           marginLeft: '8px'
         }}>
           <span>
             {`${getTipoFiltroLabel()}: ${filtroEspecifico.valor}`}
           </span>
           <IconButton
             aria-label="Limpiar filtro"
             onClick={clearAllFilters}
             size="small"
             sx={{ marginLeft: '4px' }}
           >
             <Iconify icon="material-symbols:close" width={16} />
           </IconButton>
         </Box>
       )}
     </Box>
   );
 };

 // Transformamos los datos después de recibirlos del servidor
 const data = listadoHistoricos(creditos);
 console.log("🚀 ~ Historico ~ data:", data);

 const redireccionarEdicion = (idCredito) => {
   const credito = creditos.filter((credito) => credito.id === idCredito)[0];
   if (credito === undefined) {
     return;
   }
   dispatch(cargarCreditoAEditar(credito));
   navigate(`/admin/${MAIN_PATH}/${PATH_NAME.visualizar_credito_historico}`, { replace: true });
 };

 const columnas = [
   {
     label: 'Nombre',
     name: 'nombre',
     options: {
       filter: true,
     },
   },
   {
     label: 'Cedula',
     name: 'cedula',
     options: {
       filter: true,
     },
   },
   {
     label: 'N. Crédito',
     name: 'creditoId',
     options: {
       filter: true,
     },
   },
   {
     label: 'Monto Aprobado',
     name: 'valor_Aprobado',
     options: {
       filter: true,
     },
   },
   {
     label: 'Fecha Cancelado',
     name: 'fecha_Cancelado',
     options: {
       filter: true,
     },
   },
   {
     name: 'Gestionar',
     options: {
       sort: false,
       filter: false,
       customBodyRender: (_value, tableMeta) => (
         <Tooltip title="Gestionar" aria-label="Gestionar">
           <IconButton aria-label="Gestionar" onClick={() => redireccionarEdicion(tableMeta.rowData[2])}>
             <Iconify icon="material-symbols:edit-square-outline" />
           </IconButton>
         </Tooltip>
       ),
     },
   },
 ];

 // Opciones adicionales para la tabla
 const tableOptions = {
   customToolbar,
   search: !filtroEspecifico,
   searchPlaceholder: filtroEspecifico ? 'Filtrado activo' : 'Buscar...',
   searchProps: {
     disabled: !!filtroEspecifico
   }
 };

 return (
  <TableListPagination 
    titulo="Histórico de Créditos" 
    columnas={columnas} 
    data={data} 
    loading={loading}
    onPageChange={handlePageChange}
    onSearch={handleSearch}
    currentPage={currentPage}
    totalCount={paginacion?.total || 0}
    disableSearch={!!filtroEspecifico}
    customOptions={tableOptions}
  />
 );
};